import { IPaginatedResponse } from '@boma/client-shared';
import {
  ILocation,
  IOrder,
  IOrderMessage,
  IVehicle,
  OrderDirection,
} from '@boma/supplier-portal/shared/entities';
import { IOrderHandshakeOffer } from '@boma/website/shared/entities';
import { createAction, props } from '@ngrx/store';

export const loadOrders = createAction('[Orders] Load Orders');

export const loadOrdersSuccess = createAction(
  '[Orders] Load Orders Success',
  props<{ payload: IPaginatedResponse<IOrder> }>()
);

export const loadOrdersFailure = createAction(
  '[Orders] Load Orders Failure',
  props<{ error: any }>()
);

export const updatePageNumber = createAction(
  '[Orders] Update Page Number',
  props<{ pageNumber: string }>()
);

export const updateOrderSearchParams = createAction(
  '[Orders] Update Inventory Search Parameters',
  props<{
    query: string;
    locationIds: string[];
    locationType: string;
    orderDirection: OrderDirection;
    customerIds: string[];
    dateRange: { fromDate: string; toDate: string };
    statuses: string[];
    orderTypes: string[];
  }>()
);

export const loadOrderDetails = createAction(
  '[Orders] Load Order Details',
  props<{ id: string }>()
);

export const loadOrderDetailsSuccess = createAction(
  '[Orders] Load Order Details Success',
  props<{ order: IOrder }>()
);

export const loadOrderDetailsFailure = createAction(
  '[Orders] Load Order Details Failure',
  props<{ error: any }>()
);

export const loadOrderHandShake = createAction(
  '[Orders] Load Hand Shake',
  props<{ id: string }>()
);

export const loadOrderHandShakeOfferSuccess = createAction(
  '[Orders] Load Order Hand Shake Success',
  props<{ handShakeOffer: IOrderHandshakeOffer }>()
);

export const loadOrderHandShakeOfferFailure = createAction(
  '[Orders] Load Order Hand Shake Failure',
  props<{ error: any }>()
);

export const loadOrderLocations = createAction(
  '[Orders] Load Locations',
  props<{
    locationType: string;
    query: string;
    defaultOption: IVehicle | ILocation;
  }>()
);
export const loadOrderLocationsFailure = createAction(
  '[Orders] Load Locations Failure',
  props<{ error: any }>()
);

export const loadOrderLocationsSuccess = createAction(
  '[Orders] Load Locations Success',
  props<{ payload: ILocation[] | IVehicle[] }>()
);

export const updateOrderStatusToAccepted = createAction(
  '[Orders] Update Order Status To Accepted',
  props<{ id: string; comment: string }>()
);

export const updateOrderStatusToProcessing = createAction(
  '[Orders] Update Order Status To Processing',
  props<{ id: string; comment: string }>()
);

export const updateOrderStatusToLoading = createAction(
  '[Orders] Update Order Status To Loading',
  props<{ id: string; comment: string }>()
);

export const updateOrderStatusToCancelled = createAction(
  '[Orders] Update Order Status To Cancelled',
  props<{ id: string; comment: string; direction: OrderDirection }>()
);

export const updateOrderStatusToDispatched = createAction(
  '[Orders] Update Order Status To Dispatched',
  props<{ id: string; comment: string; vehicleId: string; driverId: string }>()
);

export const updateOrderStatusToFulfilled = createAction(
  '[Orders] Update Order Status To Fulfilled',
  props<{ id: string; comment: string; userPaidCashAmount: boolean }>()
);

export const loadOrderMessages = createAction(
  '[Orders] Load Order Messages',
  props<{ id: string; direction: OrderDirection }>()
);

export const loadOrderMessagesSuccess = createAction(
  '[Orders] Load Order Message Success',
  props<{ payload: IOrderMessage[] }>()
);

export const loadOrderMessagesFailure = createAction(
  '[Orders] Load Order Messages Failure',
  props<{ error: any }>()
);

export const createOrderMessage = createAction(
  '[Orders] Create Order Messages',
  props<{ id: string; direction: OrderDirection; content: string }>()
);

export const createOrderMessageSuccess = createAction(
  '[Orders] Create Order Message Success',
  props<{ message: IOrderMessage }>()
);

export const createOrderMessageFailure = createAction(
  '[Orders] Create Order Messages Failure',
  props<{ error: any }>()
);

export const markOrderAsPaid = createAction(
  '[Orders] Mark Order Charge As Paid',
  props<{ id: string; chargeId: string }>()
);

export const markChargeAsRefunded = createAction(
  '[Orders] Refund Order Charge',
  props<{ id: string; chargeId: string; }>()
);

export const cancelFulfilledOrder = createAction(
  '[Orders] Cancel Fulfilled Order',
  props<{
    id: string;
    reason: string;
    comment: string;
    restockLocation?: string;
    latitude?: number;
    longitude?: number;
  }>()
);

export const changePaymentMethod = createAction(
  '[Orders] Change Order Charge Payment Method',
  props<{ id: string; chargeId: string; newPaymentMethod: string }>()
);

export const updateOrderSupplyingLocation = createAction(
  '[Orders] Update Supplying Location',
  props<{ orderId: string; locationId: string; addMissingProducts?: boolean }>()
);
